import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import WorkDashboard from '../features/work/WorkDashboard';
import WorkProjects from '../features/work/WorkProjects';
import AuthRedirect from '../shared/AuthRedirect';
import ProtectedRoute from '../shared/ProtectedRoute';
import SubMenu from '../shared/SubMenu';
import { WORK_MENU_ITEMS } from '../config/menuConfig';
import { USER_TIERS } from '../contexts/AuthContext';

const WorkRouter = () => {
  return (
    <>
      <SubMenu items={WORK_MENU_ITEMS} />
      <Routes>
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedTiers={[USER_TIERS.FAMILY, USER_TIERS.ADMIN]}>
              <WorkDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects"
          element={
            <ProtectedRoute allowedTiers={[USER_TIERS.FAMILY, USER_TIERS.ADMIN]}>
              <WorkProjects />
            </ProtectedRoute>
          }
        />
        {/* 인증 관련 경로는 auth.ilouli.com으로 리다이렉트 */}
        <Route path="/profile" element={<AuthRedirect path="/profile" />} />
        <Route path="/login" element={<AuthRedirect path="/login" />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </>
  );
};

export default WorkRouter;
